export default "__VITE_ASSET__4Dn752rT__"